import { Badge, type BadgeProps, Tooltip } from "@mantine/core"
import { useTranslation } from "react-i18next"

export function QuestionType({ value, noTooltip, ...props }: { value: string; noTooltip?: boolean } & BadgeProps) {
  const { t } = useTranslation()
  return (
    <Tooltip label={t("Question type")} withArrow disabled={noTooltip}>
      <Badge color="gray" variant="outline" {...props}>
        {value}
      </Badge>
    </Tooltip>
  )
}
